import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { NewFormData } from '@/interfaces/components/clients/NewFormData';

interface Props {
  modelValue?: NewFormData;
  paymentTerms?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentsInformation',
  props: {
    modelValue: null,
    paymentTerms: null
  },
  emits: [
  'update:paymentTerms',
  'update:acceptedBankAccount'
],
  setup(__props: any) {

const props = __props as {
  modelValue?: NewFormData;
  paymentTerms?: any[];
};





function getValue(key: keyof NewFormData) {
  const val = props.modelValue?.[key];
  return val != null ? String(val) : undefined;
}

const acceptedBankAccount = computed(() => props.modelValue?.acceptedBankAccount);

function useFormattedOptions(listProp: keyof Props) {
  return computed(() => {
    const list = props[listProp] as any[];
    return (list ?? []).map((item) => ({
      label: `(${item.code}) ${item.description}`,
      value: String(item.id),
    }));
  });
}

const formattedPaymentTerms = useFormattedOptions('paymentTerms');

return { __sfc: true,props, getValue, acceptedBankAccount, useFormattedOptions, formattedPaymentTerms }
}

})